<template>
  <div class="kaka-container">
    <div class="kaka-back" @click="goBack">
      <i class="el-icon-arrow-left"></i>
    </div>
    <iframe
      ref="kakaFrame"
      :src="iframeSrc"
      class="kaka-iframe"
      @load="onIframeLoad"
      allow="clipboard-read; clipboard-write"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'Kaka',
  data() {
    return {
      iframeSrc: '/static/kaka/index.html'
    }
  },
  computed: {
    apiBase() {
      if (process.env.NODE_ENV === 'production-ylwai') {
        return 'https://mohe-api.s110.ylwai.cn'
      }
      if (process.env.NODE_ENV === 'production-ailo' || process.env.NODE_ENV === 'production') {
        return 'https://api.ylw.s136.ailo.vip'
      }
      return 'http://127.0.0.1:8088'
    }
  },
  mounted() {
    window.addEventListener('message', this.onMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    onIframeLoad() {
      this.sendInit()
    },
    onMessage(event) {
      if (event.data && event.data.type === 'kaka-ready') {
        this.sendInit()
      }
    },
    sendInit() {
      const token = localStorage.getItem('sessionId') || ''
      const iframe = this.$refs.kakaFrame
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({
          type: 'init',
          token: token,
          apiBase: this.apiBase
        }, '*')
      }
    }
  }
}
</script>

<style scoped>
.kaka-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}
.kaka-back {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1001;
  padding: 3px 8px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #666;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transition: background 0.2s;
}
.kaka-back:hover {
  background: rgba(255, 255, 255, 1);
}
.kaka-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Kaka/Index.vue